import { Scale, Subtract, Total } from "@pdfking/math"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { MonthName } from "../MonthName"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Lato, a wall calendar: the year low on its picture; a month under its picture, its name on a disc on the picture's foot, the contact under it, its days in four lists. */
export const Lato: CalendarDesign = {
  cover: PictureCover({ at: 0.2 }),
  page: ({ gap, language, outer, page, short, year }, month) => {
    const picture = Region(page, 0, 0.4, 1, 1)
    const disc = Scale(short, 0.2)
    const [contact, lists] = Slice.top(Slice.under(outer, picture.y, gap), Scale(short, 0.08), gap)
    return [
      Area.picture(picture, month),
      Area.badge(
        {
          height: disc,
          width: disc,
          x: Subtract(Total(outer.x, outer.width), disc),
          y: Subtract(picture.y, Scale(disc, 0.5)),
        },
        [MonthName(month, language).toUpperCase()]
      ),
      Area.footer({ ...contact, width: Scale(outer.width, 0.6) }),
      ...Area.columns(lists, month, year, 4, Scale(lists.width, 0.04)),
    ]
  },
  pages: "month",
}
